import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card, CardActionArea, CardContent, Typography, Chip, Grid, Alert, CircularProgress, Box, Button,
} from '@mui/material';
import QuizLayout from './QuizLayout';
import { quizService } from './quizService';

export default function QuizzesHub() {
  const navigate = useNavigate();
  const [quizzes, setQuizzes] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    quizService.listQuizzes()
      .then(setQuizzes)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  const action = (
    <Button variant="outlined" onClick={() => navigate('/admin/quizzes')} data-testid="quiz-admin-link">
      Manage
    </Button>
  );

  return (
    <QuizLayout title="Training Quizzes" action={action}>
      {loading && <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}><CircularProgress /></Box>}
      {error && <Alert severity="error">{error}</Alert>}
      {!loading && !error && quizzes.length === 0 && (
        <Alert severity="info">No quizzes available yet.</Alert>
      )}
      <Grid container spacing={2}>
        {quizzes.map((q) => (
          <Grid item xs={12} sm={6} key={q.id}>
            <Card>
              <CardActionArea onClick={() => navigate(`/quizzes/${q.id}`)} data-testid={`quiz-card-${q.id}`}>
                <CardContent>
                  {q.category && <Chip label={q.category} size="small" sx={{ mb: 1 }} />}
                  <Typography variant="h6">{q.title}</Typography>
                  {q.description && <Typography color="text.secondary" variant="body2">{q.description}</Typography>}
                  <Typography variant="caption" color="text.secondary">{q.question_count} questions</Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </QuizLayout>
  );
}
